import { render, staticRenderFns } from "./KitchenTable.vue?vue&type=template&id=503c3dd3&scoped=true&"
import script from "./KitchenTable.vue?vue&type=script&lang=js&"
export * from "./KitchenTable.vue?vue&type=script&lang=js&"
import style0 from "./KitchenTable.vue?vue&type=style&index=0&id=503c3dd3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503c3dd3",
  null
  
)

export default component.exports